const paymentTermTooltips = {
  V001: "Payable immediately Due net",
  V002: "Payable within 7 days Due net",
  V003: "Payable within 15 days Due net",
  V004: "Payable within 30 days Due net",
  V005: "Payable within 45 days Due net",
  V006: "Payable within 60 days Due net",
  V007: "Payable within 90 days Due net",
  V008: "Payable within 180 days Due net",
  V009: "Payable within 120 days Due net",
  V0010: "Payable within 75 days Due net",
  V0011: "Payable within 105 days Due net",
  V0012: "Payable within 135 days Due net",
  V0013: "Payable within 150 days Due net",
  V0014: "Payable within 5 days Due net",
  V0015: "Payable within 21 days Due net",
};
export default paymentTermTooltips;
